// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-boxes {
  --size: 24px;
  --first-block-clr: linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%);
  width: 100%;
  height: 100px;
  position: relative;
}

.spinner-boxes::after, .spinner-boxes::before {
  box-sizing: border-box;
  position: absolute;
  content: "";
  width: var(--size);
  height: var(--size);
  top: 50%;
  animation: up 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;
  left: 50%;
  background: var(--first-block-clr);
}

.spinner-boxes::after {
  background: var(--first-block-clr);
  top: calc(50% - var(--size));
  left: calc(50% - var(--size));
  animation: down 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;
}

@keyframes down {
  0%, 100% {
    transform: none;
  }
  25% {
    transform: translateX(100%);
  }
  50% {
    transform: translateX(100%) translateY(100%);
  }
  75% {
    transform: translateY(100%);
  }
}
@keyframes up {
  0%, 100% {
    transform: none;
  }
  25% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(-100%) translateY(-100%);
  }
  75% {
    transform: translateY(-100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AllBookings/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gFAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEG;EACC,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,0DAAA;EACA,SAAA;EACA,kCAAA;AACJ;;AAEG;EACC,kCAAA;EACA,4BAAA;EACA,6BAAA;EACA,4DAAA;AACJ;;AAEG;EACC;IACC,eAAA;EACH;EAEE;IACC,2BAAA;EAAH;EAGE;IACC,4CAAA;EADH;EAIE;IACC,2BAAA;EAFH;AACF;AAKG;EACC;IACC,eAAA;EAHH;EAME;IACC,4BAAA;EAJH;EAOE;IACC,8CAAA;EALH;EAQE;IACC,4BAAA;EANH;AACF","sourcesContent":[".spinner-boxes {\n    --size: 24px;\n    --first-block-clr: linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%);\n    width: 100%;\n    height: 100px;\n    position: relative;\n   }\n   \n   .spinner-boxes::after,.spinner-boxes::before {\n    box-sizing: border-box;\n    position: absolute;\n    content: \"\";\n    width: var(--size);\n    height: var(--size);\n    top: 50%;\n    animation: up 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;\n    left: 50%;\n    background: var(--first-block-clr);\n   }\n   \n   .spinner-boxes::after {\n    background: var(--first-block-clr);\n    top: calc(50% - var(--size));\n    left: calc(50% - var(--size));\n    animation: down 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;\n   }\n   \n   @keyframes down {\n    0%, 100% {\n     transform: none;\n    }\n   \n    25% {\n     transform: translateX(100%);\n    }\n   \n    50% {\n     transform: translateX(100%) translateY(100%);\n    }\n   \n    75% {\n     transform: translateY(100%);\n    }\n   }\n   \n   @keyframes up {\n    0%, 100% {\n     transform: none;\n    }\n   \n    25% {\n     transform: translateX(-100%);\n    }\n   \n    50% {\n     transform: translateX(-100%) translateY(-100%);\n    }\n   \n    75% {\n     transform: translateY(-100%);\n    }\n   }\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
